module.exports = __webpack_public_path__ + "static/media/star.ae3c0f2a.svg";